<!-- HEADER -->

<div *ngIf="confirmed" class="modal-header border-0">
  <button
    type="button"
    class="btn-close"
    (click)="modal.dismiss()"
    gptDataTrack="swiper-modal-close"
  >
    <i class="gpicon-close"></i>
  </button>
</div>

<!-- CONTENT -->

<div class="gp-sm-8 position-static custom-scroll-parent" #scrollContainer>
  <div
    #container
    class="modal-body position-static custom-scroll {{ containerClass }}"
  >
    <gpu-carousel
      class="flex-row position-static"
      [transition]="'fade'"
      [style.min-height.px]="minSlideHeight"
      [tapEnabled]="isMobile ? true : false"
      (pageChange)="onPageChanged($event)"
    >
      <div *ngFor="let step of steps" gpuCarouselItem>
        <div
          class="bg-white gpb-sm-32 overflow-hidden"
          [ngClass]="activePage === numberOfSlides - 1 ? 'gpb-140' : 'gpb-64'"
        >
          <div class="d-flex justify-content-center">
            <img class="d-block d-sm-none w-100" [src]="getImgSm(step)" />
            <img class="large-image d-none d-sm-block" [src]="getImgLg(step)" />
          </div>

          <div class="gpx-24 gpx-sm-64 gmt-24 gmt-sm-56">
            <p class="h6-bold gmb-24">
              {{ step.title | translate }}
            </p>
            <p
              class="p4-regular text-secondary"
              [ngClass]="last ? 'gmb-0' : 'gmb-24'"
              [innerHTML]="paragraph | translate"
              *ngFor="let paragraph of step.paragraphs; let last = last"
            ></p>
          </div>
        </div>
      </div>
      <gpu-carousel-controls
        [position]="'modal'"
        [controlsSize]="'extra_large'"
        [theme]="'mixed'"
      >
        <i
          class="d-none d-sm-block"
          gptDataTrack="swiper-modal-previous"
          gpuCarouselPrev
          [ngClass]="{ invisible: activePage === 0 }"
        ></i>
        <gpu-carousel-dots
          gptDataTrack="swiper-modal-change-manual"
        ></gpu-carousel-dots>
        <i
          class="d-none d-sm-block"
          gptDataTrack="swiper-modal-next"
          gpuCarouselNext
          [ngClass]="{ invisible: activePage === numberOfSlides - 1 }"
        ></i>
      </gpu-carousel-controls>
    </gpu-carousel>
  </div>
</div>

<!-- FOOTER -->

<div
  *ngIf="activePage === numberOfSlides - 1"
  class="modal-footer flex-column justify-content-center gpx-24 gpy-0 gp-md-24 border-top-0"
  [class.gmb-40]="isMobile"
>
  <button
    class="gbtn-1 gbtn-sq b2-semibold gmb-24 gmb-sm-0"
    gptDataTrack="swiper-modal-i-understand"
    [class.w-100]="isMobile"
    (click)="close()"
  >
    {{ confirmButtonText | translate }}
  </button>
</div>
